
import { i18n } from '@shared/i18n';

import IdField from '@shared/fields/id-field';
import StringField from '@shared/fields/string-field';
import IntegerField from '@shared/fields/integer-field';
import { GenericModel } from '@shared/model/generic-model';
import EnumeratorField from '@shared/fields/enumerator-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`subpropertySettings.finantial.payoutSchedule.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  paymentsStatementDescriptor: new StringField('paymentsStatementDescriptor', label('paymentsStatementDescriptor'), { required: true }),
  payoutsScheduleDelayDays: new IntegerField('payoutsScheduleDelayDays', label('payoutsScheduleDelayDays'), { required: true, valueType: 'integer' }),
  payoutsScheduleInterval: new EnumeratorField('payoutsScheduleInterval', label('payoutsScheduleInterval'), getSharedEnumeratorField('stripePayoutsScheduleInterval'), { required: true }), 
  payoutsScheduleMonthlyAnchor: new EnumeratorField('payoutsScheduleMonthlyAnchor', label('payoutsScheduleMonthlyAnchor'), getSharedEnumeratorField('monthDay'), { required: true, valueType: 'integer' }),
  payoutsScheduleWeeklyAnchor: new EnumeratorField('payoutsScheduleWeeklyAnchor', label('payoutsScheduleWeeklyAnchor'), getSharedEnumeratorField('weekDay'), { required: true }), 
  payoutsStatementDescriptor: new StringField('payoutsStatementDescriptor', label('payoutsStatementDescriptor'), { required: true }),
};

export class FinancialSettingsPayoutScheduleModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
